import React from "react";

interface Props {
    projectId: number;
    className?: string;
}
const defaultLogos = [
    "videoclip-orange.svg",
    "videoclip-black.svg",
    "videoclip-red.svg",
    "videoclip-yellow.svg",
    "videoclip-blue.svg",
    "videoclip-orange.svg",
    "videoclip-black.svg",
    "videoclip-red.svg",
    "videoclip-yellow.svg",
    "videoclip-blue.svg",
];
const ProjectLogo: React.FC<Props> = ({ projectId, className = "" }: Props) => {
    let randId = projectId;
    if (randId >= 100) {
        randId = +randId.toString().slice(2);
    } else if (randId >= 10) {
        randId = +randId.toString().slice(1);
    }
    const defaultLogo = defaultLogos[randId];
    return (
        <div
            className={className}
            style={{ backgroundImage: `url('/static/img/${defaultLogo}')` }}
        />
    );
};

export default ProjectLogo;
